import React from 'react';
import { useTranslation } from 'react-i18next';
import { IdeaSurveyPage } from './IdeaSurveyPage';

export const IdeaSurveyPageContainer = () => {
  const { t } = useTranslation();
  return <IdeaSurveyPage t={t} />;
};
